import $ from 'jquery';
import { AJAX_URL } from './config';

// Catch when register form is submitted
$('#register-form').on('submit', function (e) {
  // Prevent default
  e.preventDefault();

  $('.login__submit').hide();
  $('.submit__loading').show();

  // Get form data
  let describes_you = [];
  $.each($('input[name="describes_you[]"]:checked'), function () {
    describes_you.push($(this).val());
  });

  const data = {
    first_name: $('#first_name').val(),
    last_name: $('#last_name').val(),
    email: $('#email').val(),
    password: $('#user_pass').val(),
    confirm_password: $('#user_pass_confirm').val(),
    website: $('#website').val(),
    describes_you: describes_you,
    recaptchaResponse: $('#recaptchaResponse').val(),
    opt_out: $('#opt_out').val(),
    redirect_to: $('#redirect_to').val(),
    zip: $('#zip').val(),
    phone: $('#phone').val(),
    hubspotutk: $('#hubspotutk').val()
  };

  $.ajax({
    url: `${AJAX_URL}wl_post_register_form`,
    data: data,
    type: 'POST',
    dataType: 'json',
    encode: true,
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
  })
    .then(({ success, data }) => {
      $('.login__submit').show();
      $('.submit__loading').hide();

      if (!success) {
        $.each(data.errors, function (key, value) {
          $('#' + key)
            .parent()
            .append(
              '<small class="form__help u--color-red">' + value + '</small>'
            );
        });
        $('#notice').html(data.notice);
        return;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'registration',
          event_type: 'email_registration'
        });
        // Redirect to the page the user was on
        window.location.href = data.redirect;
      }
    })
    .catch((err) => console.log(err.message));
});

// After page load, check if form exists
$(document).ready(function () {
  // If it does, add the recaptcha
  if ($('#register-form').length) {
    // Attempt to read the HubSpot tracking cookie
    const hubspotCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('hubspotutk='))
      ?.split('=')[1];

    // If found, attach it as a hidden input field
    if (hubspotCookie) {
      const form = document.getElementById('register-form');
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'hubspotutk';
      hidden.id = 'hubspotutk';
      hidden.value = hubspotCookie;
      form.appendChild(hidden);
    }
  }
});

if ($('select[name="grade_level"]').length) {
  $('select[name="grade_level"]').on('change', function () {
    if (this.value === 'Other') {
      $('.grade_level_other_container').removeClass('u--display-none');
    } else {
      $('.grade_level_other_container').addClass('u--display-none');
    }
  });
}
